/* ---------------------------------------------- /*
 * Setting background of modules
/* ---------------------------------------------- */

function dataBackgroundImage(){

	var modules = $('.module-hero, .module, .module-sm, .module-xs, .background-side, .footer');

	modules.each(function() {
	    if ($(this).attr('data-background')) {
	        $(this).css('background-image', 'url(' + $(this).attr('data-background') + ')');
	    }
	});

}
